var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 502,
    height: 171,
    viewBox: "0 0 502 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2039",
    "data-name": "Rectangle 2039",
    width: 502,
    height: 171,
    transform: "translate(469 2772)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    "data-name": "Mask Group 23",
    transform: "translate(-469 -2772)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7120",
    "data-name": "Group 7120",
    transform: "translate(-0.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M-18745.215,4057l-35.748,105.667,29.334,125.53h410.133l38.98-125.53L-18341.5,4057Z",
    transform: "translate(19261.824 -1285.199)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7119",
    "data-name": "Path 7119",
    d: "M19579.352-1242.838h481.922l-72.187,367.594h-374Z",
    transform: "translate(-19100.313 4119.881)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7121",
    "data-name": "Group 7121",
    transform: "translate(-0.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    transform: "translate(600 2900.749)",
    fill: "#f7f7f7",
    stroke: "#e6e6e6",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    transform: "translate(822 2900.749)",
    fill: "#f7f7f7",
    stroke: "#e6e6e6",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7138",
    "data-name": "Path 7138",
    d: "M19390.066-1491.251s23.277,87.846,109.641,87.523,113.6-85.748,113.6-85.748",
    transform: "translate(-18781 4406.342)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7123",
    "data-name": "Path 7123",
    d: "M19644.137-1342.137l57.635-105.474,38.006,105.474Z",
    transform: "translate(-18778.816 4219.412)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7124",
    "data-name": "Path 7124",
    d: "M19739.777-1342.137l-57.635-105.474-38.006,105.474Z",
    transform: "translate(-19165.098 4220)",
    fill: "#e6e6e6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.7d33bb25d75cc7bece8ea328e479add4.svg";
export { ForwardRef as ReactComponent };